import { vMaska } from 'maska/vue'
// import Vue from 'vue'

// Vue.directive('maska', vMaska)

// nuxt 3
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('maska', vMaska)
})
